export const InitialFilterOptions = {
	accounts: [],
	designers: [],
	brands: [],
	status: [],
	types: [],
	assignedTo: [],
	productLines: [],
	hasStatusTriggered: false
};

export enum RequestCacheKeys {
	RequestFilters = "_cabinet_request_filters"
}
